module.exports = __webpack_public_path__ + "img/1.cbc61c5e.jpg";